import { APIClient, PaginatedResponse } from '@frontend/api-utils';
import { Transaction, TransactionStateName, TransactionTriggerName } from '@frontend/transaction/types';
import { PossibleTrigger, TriggerBody } from '@frontend/workflow/types';

export class TransactionWorkflowClient extends APIClient {
    public static readonly endpoint = '/transaction-api/v1';

    public static async updateTransactionState(accountId: string, transactionId: string, state: TransactionStateName): Promise<Transaction> {
        const response = await this.patch(`${this.endpoint}/accounts/${accountId}/transactions/${transactionId}/change-state`, { state: state });
        return await this.handleResponse<Transaction>(response);
    }
    /**
     * @param accountId
     * @param transactionId
     * @param trigger as WorkflowStepTrigger
     * @returns
     */
    public static async triggerTransactionState(accountId: string, transactionId: string, trigger: TriggerBody<TransactionTriggerName>): Promise<void> {
        const response = await this.post(`${this.endpoint}/accounts/${accountId}/transactions/${transactionId}/trigger`, trigger);
        return await this.handleVoidResponse(response);
    }

    public static async fetchTransactionPossibleTriggers(
        accountId: string,
        transactionId: string
    ): Promise<PossibleTrigger<TransactionTriggerName, TransactionStateName>[]> {
        const response = await this.fetch(`/transaction-api/v2/accounts/${accountId}/transactions/${transactionId}/possible-triggers`);
        const body = await this.handleResponse<PaginatedResponse<PossibleTrigger<TransactionTriggerName, TransactionStateName>>>(response);
        return body.results;
    }
}
